"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('detection', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45049 34.8494L10.4402 31.5017L10.9536 25.6319L18.9335 18.936L27.7111 11.5707L30.9029 8.8924C33.9878 6.30384 38.5871 6.70623 41.1757 9.79115C43.7642 12.8761 43.3618 17.4753 40.2769 20.0639L37.0851 22.7422L28.3075 30.1074L20.3276 36.8033L14.4602 36.2925L10.4733 39.6379C9.14959 40.7487 7.17604 40.576 6.06529 39.2522C4.95585 37.9301 5.12831 35.9588 6.45049 34.8494Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M23.4369 9.71777L38.2078 27.3211",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M18.576 29.0002L24.3023 24.0002",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;